// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__24Lxt","title":"AfterImages90_title__3V0mH","images":"AfterImages90_images__1XIUf"};